export default {
      id: "icon-conversions-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-conversions",
      toString: function () {
        return this.url;
      }
    }